import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { FlatList as RNFlatList, Switch as RNSwitch, TextInput as RNTextInput, ScrollView as RNScrollView, View } from "react-native";
import createNativeWrapper from "../handlers/createNativeWrapper";
export var ScrollView = createNativeWrapper(RNScrollView, {
    disallowInterruption: false
});
export var Switch = createNativeWrapper(RNSwitch, {
    shouldCancelWhenOutside: false,
    shouldActivateOnStart: true,
    disallowInterruption: true
});
export var TextInput = createNativeWrapper(RNTextInput);
export var DrawerLayoutAndroid = function() {
    console.warn("DrawerLayoutAndroid is not supported on web!");
    return /*#__PURE__*/ _jsx(View, {});
};
// RefreshControl is implemented as a functional component, rendering a View
// NativeViewGestureHandler needs to set a ref on its child, which cannot be done
// on functional components
export var RefreshControl = createNativeWrapper(View);
export var FlatList = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    return /*#__PURE__*/ _jsx(RNFlatList, _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        renderScrollComponent: function(scrollProps) {
            return /*#__PURE__*/ _jsx(ScrollView, _object_spread({}, scrollProps));
        }
    }));
});
